import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

import type { DatadogConfigInit } from '../config';
import { WEB_DEFAULTS } from '../config';

export const init = async (options: DatadogConfigInit) => {
  const opts = {
    ...WEB_DEFAULTS,
    ...options,
  };

  datadogRum.init({
    clientToken: opts.clientToken,
    applicationId: opts.applicationId,
    env: opts.env,
    service: options.serviceName, // alias
    allowedTracingOrigins: opts.firstPartyHosts, // alias
    site: opts.siteParameter, // alias
    sampleRate: opts.sessionSamplingRate, // alias
    trackInteractions: opts.trackInteractions,
    version: opts.version,
    replaySampleRate: options.replaySampleRate,
  });

  datadogRum.startSessionReplayRecording();

  // ─────────────────────────────────────────────────────────────────────

  datadogLogs.init({
    clientToken: options.clientToken,
    env: options.env,
    version: opts.version,
    sampleRate: opts.sessionSamplingRate,
    forwardErrorsToLogs: opts.forwardErrorsToLogs,
    forwardConsoleLogs: opts.forwardConsoleLogs,
    forwardReports: opts.forwardReports,
  });

  // @REVIEW: revisit to see whether we want to enhance this in some way
  // eslint-disable-next-line max-params, functional/immutable-data, unicorn/prefer-add-event-listener
  window.onerror = function (message, source, lineno, colno, error) {
    datadogLogs.logger.error(error?.message ?? '', {
      error: { stack: error?.stack },
    });
  };

  datadogLogs.logger.debug('Successfully ran `init` (web)');
};
